// extracted by mini-css-extract-plugin
export default {"root":"IconCraftFair_root__ySKKn"};